import store from '@/store';

// 将文本复制到剪切板
// 部分浏览器里, 非 https 或 localhost 网址, 会使 clipboard 对象为 undefined, 从而进入 fallback
function copyTextToClipboard(text: string) {
  if (!navigator.clipboard) {
    return fallbackCopyTextToClipboard(text);
  }
  return new Promise((resolve, reject) => {
    navigator.clipboard.writeText(text).then(() => {
      store.commit('common/setToast', { visible: true, text: '复制成功', timeout: 500 });
      resolve();
    }, () => {
      store.commit('common/setToast', { visible: true, text: '复制失败, 可能是浏览器关闭了剪切板操作权限' });
      reject();
    });
  });
}

// 从剪切板获取内容
function getTextFromClipboard() {
  if (!navigator.clipboard) {
    store.commit('common/setToast', { visible: true, text: '粘贴失败，无法读取剪贴板', timeout: 500 });
    return;
  }
  return new Promise((resolve, reject) => {
    navigator.clipboard.readText().then((clipText) => {
      resolve(clipText);
    }).catch(() => {
      reject();
    });
  });
}

// 兼容处理（如果弹窗里有 v-btn 组件，则 textarea.focus() 会失效）
// 原因是弹窗里的任意 v-btn 都会优先获取焦点，从而阻止 textarea 获取焦点，导致 select() 选中不到文字
function fallbackCopyTextToClipboard(text: string) {
  return new Promise((resolve, reject) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;

    // 避免页面出现滚动条
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.position = 'fixed';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      const successful = document.execCommand('copy');
      const msg = successful ? '复制成功' : '复制失败，请重试';
      store.commit('common/setToast', { visible: true, text: msg, timeout: 500 });
      resolve();
    } catch (err) {
      store.commit('common/setToast', { visible: true, text: '复制失败, 该浏览器不支持操作剪切板' });
      reject();
    }

    document.body.removeChild(textarea);
  });
}

export default copyTextToClipboard;

export {
  copyTextToClipboard,
  getTextFromClipboard,
};
